import React from 'react';
import './nosotros.css';

function Nosotros() {
    return (
        <section className='nosotros'>
            <h2 className='titulo'>¿QUÉ ES <strong className='brand'>GALIDÉ</strong>?</h2>
            <p className='texto'>En una galaxia lejana, una <b>agencia de marketing digital</b>, guia a las empresas hacia la consecución de sus metas en el vasto entorno digital. Ofrece servicios integrales de <b>publicidad, diseño, SEO y gestión de redes sociales</b> para elevar la visibilidad y expandir el alcance de las empresas en la red estelar. Además, proporciona un <b>escudo protector de marca</b> para salvaguardar la identidad y reputación de las empresas, manteniéndolas a salvo de amenazas potenciales en el constante cambio del paisaje digital galáctico. Que la Fuerza del Marketing Digital te acompañe.</p>
        </section>
    );
}

export default Nosotros;